module.exports = __webpack_public_path__ + "img/NHaasGroteskTXPro-75Bd.5f1cee3.svg";